export default __webpack_public_path__ + "static/media/4.eb7bd8db.jpg";